// This enum is base on the data we get from the backend
export enum RepresentationTypeEnum {
  AGENCY_REPRESENTATION = 'agency_representation',
  NON_REPRESENTED = 'non_represented',
}
